export default (a, b) => (a?.toString() || '').toLowerCase().localeCompare((b?.toString() || '').toLowerCase());
